<template>
  <main class="fixed_adjustment">
    <section class="section_box">
      <div class="inner">
        <h2 class="tit_style05">パスワード再設定</h2>
        <form class="form_area" @submit.prevent="onsubmit(email)">
          <label for="email" class="form_title"
            >ご登録されているメールアドレスをご入力ください。</label
          >
          <p v-if="error !== null" class="error_txt mgb40">
            入力されたメールアドレスは登録されておりません。
            <!-- {{ error }} -->
          </p>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="メールアドレス"
            required
            v-model="email"
          />
          <input type="submit" value="パスワード再設定" />
        </form>
      </div>
    </section>
  </main>
</template>

<script>
import { FORGOT } from "@/store/actions.type";

export default {
  name: "ForgotMail",
  data() {
    return {
      email: null,
      error: null
    };
  },
  methods: {
    onsubmit(value) {
      this.$store
        .dispatch(FORGOT, value)
        .then(() => this.$router.push({ name: "forgotSent" }))
        .catch(({ response }) => {
          this.error = response.data.title;
        });
    }
  }
};
</script>

<style></style>
